import React from "react";
import { CardActionArea, CardContent, Box, CardActions } from "@mui/material";
import { InnerWrapper, OuterWrapper } from "../../wrapper/wrapper";
import {
  CardBody,
  CardImage,
  Designation,
  Name,
  ReviewBody,
  Title,
} from "./testimonials.components";
import QuoteIcon from "../../../images/reviews/quote.png";
import StarIcon from "@mui/icons-material/Star";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import Reviews from "./reviews";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./testimonials.css";

function Testimonials() {
  var settings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 970,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  return (
    <OuterWrapper sx={{ py: "150px", bgcolor: "#F8FBFE" }}>
      <InnerWrapper>
        <Title sx={{ px: { xs: 1.5 }, fontSize: { xs: 28, sm: "32px" } }}>
          Reviews and Alumni Word
        </Title>
        <Box component={Slider} {...settings} sx={{ px: { xs: "10px" } }}>
          {Reviews.map((data) => {
            return (
              <Box>
                <CardBody
                  sx={{
                    width: { md: "360px !important" },
                    mx: { md: 2.5 },
                    pb: { xs: "77px", md: "102px" },
                  }}
                >
                  <CardActionArea>
                    <CardContent sx={{ px: 5, height: 335 }}>
                      <Box
                        component="img"
                        src={QuoteIcon}
                        alt=""
                        sx={{ width: 64, mx: "auto", my: 4 }}
                      />
                      <ReviewBody>{data.review}</ReviewBody>
                    </CardContent>
                  </CardActionArea>
                  <CardActions sx={{ justifyContent: "center" }}>
                    {data.stars.map((star) => {
                      return star === 1 ? <StarIcon /> : <StarOutlineIcon />;
                    })}
                  </CardActions>
                </CardBody>
                <CardImage
                  component="img"
                  src={data.imgUrl}
                  alt=""
                  sx={{ top: { xs: "-57px", md: "-65px" } }}
                />
                <Name>{data.name}</Name>
                <Designation>{data.designation}</Designation>
              </Box>
            );
          })}
        </Box>
      </InnerWrapper>
    </OuterWrapper>
  );
}

export default Testimonials;
